import axios from "axios";
import { useAxiosHook } from "./useAxiosHook";
import isNil from "lodash/isNil";

const ROUTE_PREFIX = "loan_sizer";

export const useLoanSizerHook = () => {
  const {
    axiosPostIsLoading,
    isLoading,
    axiosGetIsLoading,
    axiosError,
    axiosPostRequest,
  } = useAxiosHook();

  const loading = isLoading || axiosGetIsLoading || axiosPostIsLoading;
  const error = axiosError;

  // -----------------------------
  //  POST /users/create_user
  // -----------------------------
  const createRtlSizerPricing = async ({ data, onSuccessFn, onErrorFn }) => {
    if (isNil(data)) {
      console.error("Data is required to create RTL Sizer Pricing");
      return;
    }
    const endpoint = `${ROUTE_PREFIX}/pricing/rtl_loan`;
    const source = axios.CancelToken.source();
    await axiosPostRequest({
      name: "Create RTL Sizer Pricing",
      path: endpoint,
      payload: data,
      cancelSource: source,
      onSuccessFn,
      onErrorFn,
    });
  };

  const createPartnerSizerPricingHandHomebuyer = async ({
    data,
    onSuccessFn,
    onErrorFn,
  }) => {
    if (isNil(data)) {
      console.error("Data is required to create RTL Sizer Pricing");
      return;
    }
    const endpoint = `${ROUTE_PREFIX}/pricing/partner_loan/handsomehomebuyer`;
    const source = axios.CancelToken.source();

    await axiosPostRequest({
      name: "Create Handsome Homebuyer RTL Sizer Pricing",
      path: endpoint,
      payload: data,
      cancelSource: source,
      onSuccessFn,
      onErrorFn,
    });
  };

  return {
    error,
    loading,
    createRtlSizerPricing,
    createPartnerSizerPricingHandHomebuyer,
  };
};
